(function () {
  'use strict';

  var EVENT_NAME = 'Cart Snapshot Full';
  var STORAGE_KEY = 'luvieh_cart_snapshot_signature_prod_v1';
  var inflightSignature = null;
  var timer = null;
  var MAX_KLAVIYO_ATTEMPTS = 50;

  function moneyFromCents(value) {
    var n = Number(value || 0);
    return Math.round(n) / 100;
  }

  function absoluteUrl(path) {
    try {
      return new URL(path || '/', window.location.origin).href;
    } catch (e) {
      return window.location.origin + (path || '/');
    }
  }

  function normalizedProperties(properties) {
    if (!properties || typeof properties !== 'object') return {};
    var output = {};
    Object.keys(properties).sort().forEach(function (key) {
      var value = properties[key];
      if (value !== null && value !== undefined && value !== '') output[key] = value;
    });
    return output;
  }

  function buildRecoveryUrl(items) {
    if (!items || !items.length) return window.location.origin + '/cart';
    var quantities = {};
    items.forEach(function (item) {
      var variantId = String(item.variant_id || item.id || '');
      if (!variantId) return;
      quantities[variantId] = (quantities[variantId] || 0) + Number(item.quantity || 0);
    });
    var parts = Object.keys(quantities).map(function (variantId) {
      return encodeURIComponent(variantId) + ':' + encodeURIComponent(quantities[variantId]);
    });
    return window.location.origin + '/cart/' + parts.join(',') + '?storefront=true';
  }

  function buildItems(cart) {
    return (cart.items || []).map(function (item) {
      return {
        Key: item.key || '',
        VariantID: String(item.variant_id || item.id || ''),
        ProductID: String(item.product_id || ''),
        ProductName: item.product_title || item.title || '',
        VariantName: item.variant_title || '',
        Quantity: Number(item.quantity || 0),
        UnitPrice: moneyFromCents(item.final_price != null ? item.final_price : item.price),
        LinePrice: moneyFromCents(item.final_line_price != null ? item.final_line_price : item.line_price),
        ImageURL: item.image || '',
        URL: absoluteUrl(item.url),
        SKU: item.sku || '',
        Properties: normalizedProperties(item.properties)
      };
    });
  }

  function signatureForCart(cart) {
    return JSON.stringify({
      currency: cart.currency || 'GBP',
      total_price: Number(cart.total_price || 0),
      items: (cart.items || []).map(function (item) {
        return {
          key: item.key || '',
          variant_id: String(item.variant_id || item.id || ''),
          quantity: Number(item.quantity || 0),
          final_line_price: Number(item.final_line_price != null ? item.final_line_price : item.line_price || 0),
          properties: normalizedProperties(item.properties)
        };
      })
    });
  }

  function buildPayload(cart, signature) {
    return {
      ItemCount: Number(cart.item_count || 0),
      Currency: cart.currency || 'GBP',
      CartTotal: moneyFromCents(cart.total_price),
      CartTotalCents: Number(cart.total_price || 0),
      CartToken: cart.token || '',
      RecoveryURL: buildRecoveryUrl(cart.items || []),
      CartSignature: signature,
      Items: buildItems(cart)
    };
  }

  function saveSignature(signature) {
    try { window.localStorage.setItem(STORAGE_KEY, signature); } catch (e) {}
  }

  function previousSignature() {
    try { return window.localStorage.getItem(STORAGE_KEY); } catch (e) { return null; }
  }

  function clearInflight(signature) {
    if (inflightSignature === signature) inflightSignature = null;
  }

  function trackWhenReady(cart, signature, attempt) {
    if (window.klaviyo && typeof window.klaviyo.track === 'function') {
      try {
        var result = window.klaviyo.track(EVENT_NAME, buildPayload(cart, signature));
        if (result && typeof result.then === 'function') {
          result.then(function (success) {
            if (success === true) saveSignature(signature);
            clearInflight(signature);
          }, function () {
            clearInflight(signature);
          });
        } else {
          if (result === true) saveSignature(signature);
          clearInflight(signature);
        }
      } catch (e) {
        clearInflight(signature);
      }
      return;
    }

    if (attempt >= MAX_KLAVIYO_ATTEMPTS) {
      clearInflight(signature);
      return;
    }

    window.setTimeout(function () {
      trackWhenReady(cart, signature, attempt + 1);
    }, 200);
  }

  function sendToKlaviyo(cart) {
    var signature = signatureForCart(cart);
    if (signature === previousSignature() || signature === inflightSignature) return;
    inflightSignature = signature;
    trackWhenReady(cart, signature, 0);
  }

  function readCart() {
    return window.fetch('/cart.js', {
      method: 'GET',
      credentials: 'same-origin',
      headers: { 'Accept': 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Cart snapshot fetch failed');
        return response.json();
      })
      .then(sendToKlaviyo)
      .catch(function () {});
  }

  function scheduleSnapshot() {
    window.clearTimeout(timer);
    timer = window.setTimeout(readCart, 300);
  }

  function bindJQueryCartEvents() {
    if (!window.jQuery) return false;
    window.jQuery(document).on(
      'afterAddItem.ajaxCart afterChangeItem.ajaxCart afterGetCart.ajaxCart afterCartLoad.ajaxCart',
      scheduleSnapshot
    );
    window.jQuery(document).ajaxComplete(function (event, xhr, settings) {
      var url = settings && settings.url ? String(settings.url) : '';
      if (/\/cart\/(add|change|update|clear)(\.js)?(?:\?|$)/i.test(url)) scheduleSnapshot();
    });
    return true;
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scheduleSnapshot, { once: true });
  } else {
    scheduleSnapshot();
  }

  if (!bindJQueryCartEvents()) {
    var jqueryPolls = 0;
    var jqueryTimer = window.setInterval(function () {
      jqueryPolls += 1;
      if (bindJQueryCartEvents() || jqueryPolls >= 50) window.clearInterval(jqueryTimer);
    }, 200);
  }
})();
